
export default function ChannelsSection() {
  const channels = [
    {
      icon: 'ri-mail-line',
      title: 'IA E-mail',
      description: 'Campanhas Inbound e Outbound personalizadas com automação inteligente',
      features: ['Segmentação avançada', 'Personalização em massa', 'A/B Testing automático']
    },
    {
      icon: 'ri-global-line',
      title: 'IA de Voz para Site',
      description: 'Atendimento 24/7 com IA de Voz integrada ao seu website',
      features: ['Conversas naturais', 'Qualificação automática', 'Integração CRM']
    },
    {
      icon: 'ri-phone-line',
      title: 'IA de Voz para Telefonia',
      description: 'Automação de atendimentos receptivos e ativos via telefone',
      features: ['Discagem inteligente', 'Scripts adaptativos', 'Análise de sentimento']
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'IA de WhatsApp',
      description: 'Prospecção comercial automatizada e eficiente via WhatsApp',
      features: ['Mensagens personalizadas', 'Chatbot inteligente', 'Gestão de conversas']
    },
    {
      icon: 'ri-instagram-line',
      title: 'IA de Redes Sociais',
      description: 'Transformação dos canais sociais em máquinas de prospecção',
      features: ['Engajamento automático', 'Identificação de prospects', 'Conteúdo otimizado']
    },
    {
      icon: 'ri-megaphone-line',
      title: 'IA de Marketing',
      description: 'Conteúdo personalizado e campanhas estratégicas multicanal',
      features: ['Automação de campanhas', 'Análise preditiva', 'ROI otimizado']
    }
  ];

  return (
    <section id="channels" className="py-16 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Canais de Prospecção
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Revolucione sua prospecção comercial com nossas soluções de IA multicanal. Sua marca mais Conectada, Ágil e Eficiente
          </p>
        </div>

        {/* Channels Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {channels.map((channel, index) => (
            <div 
              key={index} 
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-6 hover:bg-gray-800/70 hover:border-blue-500/50 hover:scale-105 transition-all duration-300 group h-full flex flex-col"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${channel.icon} text-lg text-white`}></i>
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors leading-tight">
                    {channel.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {channel.description}
                  </p>
                </div>
              </div>

              <div className="mt-auto">
                <ul className="space-y-1.5">
                  {channel.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-xs text-gray-300">
                      <i className="ri-check-line text-green-400 mr-2 flex-shrink-0 text-sm"></i>
                      <span className="leading-tight">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
